@let eppConfigValue = eppConfig();
@if (!isLoading()) {
  @let meteogramDataValue = meteogramData();
  @let userParametersetsValue = userParametersets();
  @if (eppConfigValue.view === 'meteogram') {
    @if (meteogramDataValue) {
      <div class="meteogram-container">
        <app-epp-meteogram
          [eppData]="meteogramDataValue"
          [rebuild]="rebuildMeteogram"
          [parameterset]="eppConfigValue.parameterset"
          [dashboardView]="true"></app-epp-meteogram>
      </div>
      @if (userParametersetsValue.length > 0) {
        <div class="meteogram-index-container">
          <app-epp-matrix
            [parameterType]="'index'"
            [parametersetName]="eppConfigValue.parameterset"
            [tableData]="meteogramDataValue"
            [resolution]="eppConfigValue.resolution"
            [userParameters]="userParametersetsValue"
            [parameterChanged]="tableParameterChanged"
            [parameterDefinitions]="parameterDetails"
            [dashboardView]="true"></app-epp-matrix>
        </div>
      }
    }

    @if (userParametersetsValue.length > 0 && meteogramDataValue) {
      <!-- condition matrix -->
      <app-epp-matrix
        [parameterType]="'condition'"
        [parametersetName]="eppConfigValue.parameterset"
        [tableData]="meteogramDataValue"
        [resolution]="eppConfigValue.resolution"
        [userParameters]="userParametersetsValue"
        [parameterChanged]="tableParameterChanged"
        [parameterDefinitions]="parameterDetails"
        [dashboardView]="true"></app-epp-matrix>
    }
  }

  @if (
    eppConfigValue.view === 'table' &&
    meteogramDataValue &&
    userParametersetsValue.length > 0
  ) {
    <div class="dashboard-epp-table-container">
      <app-epp-table
        [tableData]="meteogramDataValue"
        [userParameters]="userParametersetsValue"
        [parameterDefinitions]="parameterDetails"
        [resolution]="eppConfigValue.resolution"
        [dashboardView]="true"
        [parameterset]="eppConfigValue.parameterset"
        (columnOrderChanged)="
          onTableColumnOrderChanged($event)
        "></app-epp-table>
    </div>
  }
} @else {
  <app-loading-overlay text="Daten werden geladen..." [fullScreen]="false">
  </app-loading-overlay>
}
